import React, { useEffect } from "react";
import { useState } from "react";

const TabFilter = ({ tabData, onTabSwitch, count, isTransaction = false }) => {
  const [tabDetails, setTabDetails] = useState(tabData);

  useEffect(() => {
    setTabDetails(tabData);
  }, [count]);

  return (
    <div className="d-flex justify-content-start algin-items-center">
      {tabDetails.map((data, index) => {
        return (
          <div
            className={`tab-filter mr-3 ${data.active ? "tab-active" : ""}`}
            onClick={() => {
              onTabSwitch(data?.label);
              setTabDetails(
                tabDetails.map((_, i) => {
                  if (index == i) return (_ = { ..._, active: true });
                  return (_ = { ..._, active: false });
                })
              );
            }}
          >
            {isTransaction ? data?.label : `${data?.count} - ${data?.label}`}
          </div>
        );
      })}
    </div>
  );
};

export default TabFilter;
